// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2aQGC","content":"LayoutSettings_content__3Dct4"};